/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


/** Import ENVIRONMENTAL VARIABLES */
import ENV from "react-dotenv";


import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";


export const prepareRestApiRequestToken = (Headers: Headers): AUTHORIZATION_TOKEN_INTERFACE | null => {

    let TOKEN_VALUE: string | null = Headers.get("Authorization");
    let TOKEN_VALID_TIME: string | number | null = Headers.get("AuthorizationLifetime");

    if (+ENV?.TOKEN_AUTHORIZATION === 0) {
        TOKEN_VALUE = TOKEN_VALUE || "auth";
        TOKEN_VALID_TIME = TOKEN_VALID_TIME || 300;
    }

    if (!TOKEN_VALUE || !TOKEN_VALID_TIME) return null;

    return {
        tokenValue: TOKEN_VALUE,
        tokenValidTime: +TOKEN_VALID_TIME,
        tokenCreateDate: (new Date()).getTime()
    };

}


export default prepareRestApiRequestToken;
